class PdpSubnav extends HTMLElement {
  constructor() {
    super();
    this.handleCategoryClick = this.handleCategoryClick.bind(this);
    this.handlePrevClick = this.handlePrevClick.bind(this);
    this.handleNextClick = this.handleNextClick.bind(this);
    this.handleScroll = this._updateNavButtons.bind(this);
    this.handleTablistKeydown = this.handleTablistKeydown.bind(this);
  }

  connectedCallback() {
    this.currentCategory = null;

    this.categoryLinks = this.querySelectorAll('.pdp_subnav_category');
    this.subnavLinksContainers = this.querySelectorAll('.pdp_subnav_links');
    this.prevButton = this.querySelector('.pdp_subnav_prev');
    this.nextButton = this.querySelector('.pdp_subnav_next');
    // this.subnavLinks = this.querySelectorAll('.pdp_subnav_link')

    this.tablist = this.querySelector('.pdp_subnav_categories');

    this.categoryLinks.forEach((link) => {
      link.addEventListener('click', this.handleCategoryClick);
    });
    this.tablist?.addEventListener('keydown', this.handleTablistKeydown);

    this.subnavLinksContainers.forEach((c) => c.addEventListener('scroll', this.handleScroll));

    this.prevButton?.addEventListener('click', this.handlePrevClick);
    this.nextButton?.addEventListener('click', this.handleNextClick);

    // Show first category (assumes your Liquid already marks “active” if needed)
    //const firstCat = this.categoryLinks[0]?.dataset.subnavCategory
    //if (firstCat) this.showCategory(firstCat);

    // window.requestAnimationFrame(() => this._scrollActiveLinkIntoView());
    this._updateNavButtons();
    this._scrollActiveLinkIntoView();
  }

  disconnectedCallback() {
    this.categoryLinks.forEach((link) => {
      link.removeEventListener('click', this.handleCategoryClick);
    });
    this.tablist?.removeEventListener('keydown', this.handleTablistKeydown);
    this.prevButton?.removeEventListener('click', this.handlePrevClick);
    this.nextButton?.removeEventListener('click', this.handleNextClick);
    this.subnavLinksContainers.forEach((c) => c.removeEventListener('scroll', this.handleScroll));
  }

  handleCategoryClick(e) {
    e.preventDefault();
    this.showCategory(e.currentTarget.dataset.subnavCategory);
  }

  handleTablistKeydown(e) {
    const links = Array.from(this.categoryLinks);
    const currentIndex = links.indexOf(document.activeElement);
    if (currentIndex === -1) return;

    let nextIndex;
    switch (e.key) {
      case 'ArrowRight':
        nextIndex = (currentIndex + 1) % links.length;
        break;
      case 'ArrowLeft':
        nextIndex = (currentIndex - 1 + links.length) % links.length;
        break;
      case 'Home':
        nextIndex = 0;
        break;
      case 'End':
        nextIndex = links.length - 1;
        break;
      default:
        return;
    }

    e.preventDefault();
    const nextLink = links[nextIndex];
    nextLink.focus();
    this.showCategory(nextLink.dataset.subnavCategory);
  }

  handlePrevClick(e) {
    e.preventDefault();
    const container = this._getActiveContainer();
    if (!container) return;
    const amount = this._getScrollAmount(container);
    container.scrollBy({ left: -amount, behavior: 'smooth' });
  }

  handleNextClick(e) {
    e.preventDefault();
    const container = this._getActiveContainer();
    if (!container) return;
    const amount = this._getScrollAmount(container);
    container.scrollBy({ left: amount, behavior: 'smooth' });
  }
  showCategory(category) {
    // Update active class and tab state on category links
    this.categoryLinks.forEach((link) => {
      const isActive = link.dataset.subnavCategory === category;
      link.classList.toggle('active', isActive);
      link.setAttribute('aria-selected', isActive);
      link.setAttribute('tabindex', isActive ? '0' : '-1');
    });

    // Show/hide subnav links containers
    this.subnavLinksContainers.forEach((container) =>
      container.dataset.subnavCategory === category
        ? container.classList.add('active')
        : container.classList.remove('active')
    );
    this._scrollActiveLinkIntoView();
    // Store the current category
    this.currentCategory = category;
    this._updateNavButtons();
  }

  _getActiveContainer() {
    return this.querySelector('.pdp_subnav_links.active');
  }

  _getScrollAmount(container) {
    const link = container.querySelector('.pdp_subnav_link');
    if (!link) return container.clientWidth;
    const gap = parseInt(getComputedStyle(container).gap) || 0;
    return link.offsetWidth + gap;
  }

  _scrollActiveLinkIntoView() {
    const container = this._getActiveContainer();
    const activeLink = container?.querySelector('.pdp_subnav_link.active');
    activeLink?.scrollIntoView({
      behavior: 'auto',
      inline: 'center',
      block: 'nearest',
    });
  }

  _updateNavButtons() {
    const container = this._getActiveContainer();
    if (!container || !this.prevButton || !this.nextButton) return;

    this.prevButton.disabled = container.scrollLeft <= 0;
    this.nextButton.disabled =
      container.scrollLeft + container.clientWidth >= container.scrollWidth - 1;
  }
}

// Define the custom element
customElements.define('pdp-subnav', PdpSubnav);
